module.exports = __webpack_public_path__ + "static/Cryption-8e0ac66c271bbc1c371cd94a3e5134ed.png";